import { useEffect, useState } from "react";
import { API } from "@/lib/api";

/**
 * ClientBanner — small notice shown at the top of every client-facing
 * public page while Caring is migrating from the legacy CRM to the new
 * system. Toggled by admins via /settings/system.
 *
 * Fails open: renders nothing if the endpoint returns non-2xx, so the
 * public pages never break because the banner service hiccuped.
 */
export default function ClientBanner() {
  const [state, setState] = useState({ enabled: false, text: "" });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${API}/public/client-banner`);
        if (!r.ok) return;
        const j = await r.json();
        if (!cancelled) setState({ enabled: !!j.enabled, text: j.text || "" });
      } catch {
        /* silent — banner is optional */
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!state.enabled || !state.text.trim()) return null;

  return (
    <div
      data-testid="client-transition-banner"
      // Hardcoded warm-amber palette so the banner reads the same for the
      // client regardless of any theme toggling in the admin app — this
      // is a client-facing chrome, not a themed surface.
      className="w-full bg-[#FDEBCF] border-b border-[#F0C381] text-[#8F4F0A] text-sm"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-2.5 leading-snug">
        <span className="font-semibold mr-1">Aviso · </span>
        {state.text}
      </div>
    </div>
  );
}
